import React, { useEffect } from "react";
import styled from "styled-components";
import { func, object as obj } from "prop-types";
import { phonePageSubmitted } from "data/segmentCustomEvents";
import Copy from "components/shared/Copy";
import { EmailIcon } from "components/icons";
import OnboardingCheckbox from "components/onboarding/components/OnboardingCheckbox";
import OnboardingInput from "components/onboarding/components/OnboardingInput";

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;

  @media (min-width: ${({ theme }) => theme.screen.tablet}px) {
    margin: 0 2rem;
  }
`;

const EmailAndSubmissionPage = ({
  formData,
  fieldValidation,
  handleChange,
  invalidMessages
}) => {
  useEffect(() => {
    phonePageSubmitted();
  }, []);
  return (
    <>
      <Copy
        color="darkBlue"
        margin="0 auto 1rem"
        size={1}
        weight="600"
        maxWidth="400px"
      >
        Step 3: Email Address
      </Copy>
      <Copy margin="1rem auto" size={0.8}>
        Get care matches sent straight to your inbox
      </Copy>
      <EmailIcon />
      <OnboardingInput
        error={invalidMessages.email}
        name="email"
        placeholder="Email address"
        onBlur={fieldValidation}
        onChange={handleChange}
        type="email"
        value={formData.email}
        width="300px"
      />
      <CheckboxContainer>
        <OnboardingCheckbox
          name="newsLetterSignup"
          checked={!!formData.newsLetterSignup}
          className="smallText"
          label="I am happy to receive occasional marketing emails"
          onChange={handleChange}
        />
        <OnboardingCheckbox
          error={invalidMessages.confirmed_tos}
          name="confirmed_tos"
          checked={!!formData.confirmed_tos}
          className="smallText"
          label={
            <div>
              I agree to the SuperCarers{" "}
              <a href="/privacy/" target="_blank">
                privacy policy
              </a>{" "}
              and{" "}
              <a href="/terms/" target="_blank">
                terms and conditions
              </a>
              .
            </div>
          }
          onChange={handleChange}
        />
      </CheckboxContainer>
    </>
  );
};

EmailAndSubmissionPage.propTypes = {
  fieldValidation: func.isRequired,
  formData: obj.isRequired,
  handleChange: func.isRequired,
  invalidMessages: obj.isRequired
};

export default EmailAndSubmissionPage;
